import { render, staticRenderFns } from "./DeliveryTableItemView.html?vue&type=template&id=2d289659&scoped=true&external"
import script from "./DeliveryTableItemView.js?vue&type=script&lang=js&external"
export * from "./DeliveryTableItemView.js?vue&type=script&lang=js&external"
import style0 from "@/applications/scrum/components/TrackerDataTable/TrackerDataTableView/TrackerDataTableView.css?vue&type=style&index=0&id=2d289659&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d289659",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VBtn from '@/agilis/wrappers/VBtn/VBtn.vue'
import VCard from '@/agilis/wrappers/VCard/VCard.vue'
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VIcon,VSpacer,VToolbar})
